import _ from "lodash";
import React, { Component, Fragment } from "react";
import {cleanValue} from "../../money-input/MoneyInput";
import Select from "../../select/Select";

const defaultIncrement = 500;
const wholeDollarFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0, minimumFractionDigits: 0 });
const dollarAndCentsFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 2 });

function getNumberFormat(value) {
  // format to two decimals if decimal present
  if (value % 1 == 0) {
    return wholeDollarFormat.format(value);
  } else {
    return dollarAndCentsFormat.format(value);
  }
}

class LoanAmountSelect extends Component {
  static createOption(val) {
    const value = typeof val !=='undefined' && val.toString ? val.toString() : '';
    return value ? { text: getNumberFormat(value), value } : null;
  }

  static getNextRoundedAmount(current, increment) {
    return Math.floor((current + increment) / increment) * increment;
  }

  get options() {
    const {
      increment = defaultIncrement,
      maxAmount = 0,
      minAmount = 0,
      value = '',
    } = this.props;

    const opts = [ LoanAmountSelect.createOption(minAmount) ];
    const tolerance = increment / 2;

    let nextAmount = minAmount;
    while (nextAmount < maxAmount) {
      nextAmount = LoanAmountSelect.getNextRoundedAmount(nextAmount, increment);

      if (nextAmount > minAmount + tolerance && nextAmount < maxAmount - tolerance) {
        opts.push(LoanAmountSelect.createOption(nextAmount));
      }
    }

    if (value && _.filter(opts, opt => opt.value === value.toString()).length === 0) {
      opts.push(LoanAmountSelect.createOption(value));
    }

    if (_.filter(opts, opt => opt.value === maxAmount.toString()).length === 0) {
      opts.push(LoanAmountSelect.createOption(Math.floor(maxAmount)));
    }

    return _.sortBy(opts, opt => parseInt(opt.value, 10));
  }

  get validation() {
    const {
      maxAmount,
      minAmount,
    } = this.props;

    return {
      validateOn: ["change"],
      required: true,

      checkValidity: value => {
        const cleanedValue = cleanValue(value);
        const amount = parseInt(cleanedValue, 10);

        if (amount < minAmount) {
          return {
            isValid: false,
            inputAttr: "minlength"
          };
        }
        if (amount > maxAmount) {
          return {
            isValid: false,
            inputAttr: "maxlength"
          };
        }

        return {
          isValid: true
        };
      },

      message: {
        default: "Please select a loan amount",
        minlength: `Your minimum loan amount is $${minAmount}`,
        maxlength: `The maximum loan amount is $${maxAmount}`
      }
    };
  }

  render() {
    const { className, value } = this.props;
    const attrs = {
      className,
      id: 'requestedAmountSelect',
      name: 'requestedAmountSelect',
      options: this.options,
      placeholder: 'Select amount to borrow',
      required: true,
      validation: this.validation,
      value,
    };

    return (
      <Select {...attrs} />
    );
  }
}

export default LoanAmountSelect;
